import { faqSeoMessageIds } from '@/assets/js/faq'

// The site defaults the published strings replace. They are dropped from the
// default meta by hid before the page's own tags go in, so the override does
// not depend on how $seoTagBuilder dedupes the array.
const OVERRIDDEN_HIDS = [
  'description',
  'og:title',
  'og:description',
  'twitter:title',
  'twitter:description'
]

// head() of a help page. A page with a meta title and description published
// for it gets those as its title, description, Open Graph and Twitter tags;
// the published titles already end in the brand ("… | Airpaz Help"), so the
// site's "%s - Airpaz" template is switched off for them.
//
// `fallback` is the page's generic head, returned for a page without ids and
// for a page whose ids the current locale does not carry — vue-i18n renders a
// missing id as the id itself, a worse title than the generic one.
export default {
  methods: {
    faqSeoHead(fallback) {
      const ids = faqSeoMessageIds(this.$route.params)

      if (!ids || !this.$te(ids.title) || !this.$te(ids.description)) {
        return fallback
      }

      const title = this.$t(ids.title)
      const description = this.$t(ids.description)
      const defaults = this.getDefaultMeta().meta.filter(
        tag => !OVERRIDDEN_HIDS.includes(tag.hid)
      )

      return this.$seoTagBuilder({
        ...this.$i18nSeo({
          title,
          meta: [
            ...defaults,
            { hid: 'description', name: 'description', content: description },
            { hid: 'og:title', property: 'og:title', content: title },
            {
              hid: 'og:description',
              property: 'og:description',
              content: description
            },
            { hid: 'twitter:title', name: 'twitter:title', content: title },
            {
              hid: 'twitter:description',
              name: 'twitter:description',
              content: description
            }
          ]
        }),
        titleTemplate: '%s'
      })
    }
  }
}
